import Accesorios from './Accesorios/Accesorios';
import { BackgroundVideoText } from './BackgroundVideoText/BackgroundVideoText';
import Banner from './Banner/Banner';
import BannerEtiquetaPersonalizada from './BannerEtiquetaPersonalizada/BannerEtiquetaPersonalizada';
import BannerStrip from './BannerStrip/BannerStripComplete';
import BannerUltraSlim from './BannerUltraSlim/BannerUltraSlim';
import BloqueH from './BloqueH/BloqueH';
import Breadcrumbs from './BreadCrumbs/BreadCrumbs';
import CardsVideo from './CardsVideo/Productos';
import DoubleCardWithVideo from './DoubleCardWithVideo/DoubleCardWithVideo';
import ExperienciasFlexible from './Experiencias/Experiencias';
import ExperienciasFlexibleCategory from './ExperienciasCategory/Productos';
import Faqs from './Faqs/Faqs';
import FaqsImagen from './FaqsImagen/FaqsImagen';
import { FlexibleContent } from './FlexibleContent';
import HeadBigcrafters from './HeadBigcrafters/HeadBigcrafters';
import ListOfCategories from './ListOfCategories/ListOfCategories';
import ListofCategoriesImages from './ListOfCategoriesImages/ListOfCategoriesImages';
import MarcasFlexible from './Marcas/Marcas';
import Mosaic from './Mosaic/Mosaic';
import PorqueComprar from './PorqueComprar/PorqueComprar';
import ProductosFlexible from './Productos/Productos';
import ProductosFlexibleCategory from './ProductosCategory/Productos';
import ProductsByBrand from './ProductsByBrand/ProductsByBrand';
import Recipe from './Recipe/Recipe';
import RecommendsConnectif from './RecommendsConnectif/RecommendsConnectif';
import SliderCards from './SliderCards/SliderCards';
import SliderShadowBox from './SliderShadowBox/SliderShadowBox';
import Stepper from './Stepper/Stepper';
import StepperNumeros from './StepperNumeros/StepperNumeros';
import StepperSlider from './StepperSlider/StepperSlider';
import { TextColumns } from './TextColumns/TextColumns';
import TimeLine from './TimeLine/TimeLine';
import UneteTribuDeArtesanos from './UneteTribuDeArtesanos/UneteTribuDeArtesanos';
import VentajasFlexible from './Ventajas/Ventajas';
import VideoImage from './VideoImage/VideoImage';
import Votaciones from './Votaciones/Votaciones';

export default FlexibleContent;
export {
  Accesorios,
  Banner,
  BannerEtiquetaPersonalizada,
  BannerStrip,
  BannerUltraSlim,
  CardsVideo,
  ExperienciasFlexible,
  Breadcrumbs,
  BloqueH,
  ExperienciasFlexibleCategory,
  FlexibleContent,
  HeadBigcrafters,
  ListOfCategories,
  ListofCategoriesImages,
  MarcasFlexible,
  Mosaic,
  PorqueComprar,
  ProductosFlexible,
  ProductsByBrand,
  Recipe,
  ProductosFlexibleCategory,
  RecommendsConnectif,
  SliderCards,
  SliderShadowBox,
  Stepper,
  StepperNumeros,
  StepperSlider,
  VentajasFlexible,
  TextColumns,
  TimeLine,
  Faqs,
  FaqsImagen,
  BackgroundVideoText,
  Votaciones,
  VideoImage,
  DoubleCardWithVideo,
  UneteTribuDeArtesanos,
};
